import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction = () => {
  // Background image path - easily customizable
  const backgroundImage = '/images/hero-background3.jpeg';

  return (
    <section 
      className="relative bg-cover bg-center bg-no-repeat text-white py-16"
      style={{
        backgroundImage: `url(${backgroundImage})`
      }}
    >
      {/* Blue gradient overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-br from-catalina-blue/50 to-san-marino/50"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold mb-4">Ready to Work With Us?</h2>
        <p className="text-xl mb-8 max-w-3xl mx-auto text-white/90">
          Let's discuss how our premium material handling equipment can enhance your workplace safety and efficiency.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/contact" 
            className="inline-block bg-white text-catalina-blue px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition duration-300 shadow-lg"
          >
            Contact Us Today
          </Link>
          <Link 
            to="/products" 
            className="inline-block bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-catalina-blue transition duration-300"
          >
            View Products
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;